import { getSettingValueSignUpFriction } from "@faire/retailer/settings/getSettingSignUpFriction";
import { getSettingValueGlobalSignUpFriction } from "@faire/retailer/settings/useSettingGlobalSignUpFriction";

export const getSettingGlobalOrNamSignUpFriction = () =>
  getSettingValueSignUpFriction() || getSettingValueGlobalSignUpFriction();
